import { Text } from '@vinted/web-ui'

import { Skeleton } from '@marketplace-web/common-components/skeleton-ui'

const BundleFooterPricingSkeleton = () => (
  <div className="u-flexbox u-flex-direction-column u-flex-none">
    <div className="u-flexbox u-flex-direction-row">
      <Text width="parent" as="span" type="subtitle">
        <Skeleton height={12} width={50} />
      </Text>
    </div>
    <Text width="parent" as="span" type="subtitle">
      <Skeleton height={12} width={90} />
    </Text>
  </div>
)

export default BundleFooterPricingSkeleton
